export default {
  notConnected: 'Zasób nie jest podłączony do żadnego obsługiwanego źródła danych.',
};
